export const registerCustomer = `
  mutation RegisterCustomer {
    registerCustomer {
      entityId
      stripeId
      createdAt
    }
  }
`;

export const createBillingPortalSession = `
  mutation CreateBillingPortalSession(
    $returnUrl: String
  ) {
    createBillingPortalSession (
      returnUrl: $returnUrl
    ) {
      id
      url
    }
  }
`;

export const createSubscriptionCheckoutSession = `
  mutation CreateSubscriptionCheckoutSession(
    $successUrl: String!
    $cancelUrl: String!
    $priceId: String!
  ) {
    createSubscriptionCheckoutSession (
      successUrl: $successUrl
      cancelUrl: $cancelUrl
      priceId: $priceId
    ) {
      id
    }
  }
`;

export const createPaymentCheckoutSession = `
  mutation CreatePaymentCheckoutSession(
    $successUrl: String!
    $cancelUrl: String!
    $priceId: String!
    $quantity: Int
  ) {
    createPaymentCheckoutSession (
      successUrl: $successUrl
      cancelUrl: $cancelUrl
      priceId: $priceId
      quantity: $quantity
    ) {
      id
    }
  }
`;

export const createBucket = `
  mutation CreateBucket(
    $bucketName: String
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
  ) {
    createBucket(
      bucketName: $bucketName
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
    )
  }
`;
export const createStaticBucket = `
  mutation CreateStaticBucket(
    $bucketName: String
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
  ) {
    createStaticBucket(
      bucketName: $bucketName
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
    )
  }
`;

export const createStandardQueue = `
  mutation CreateStandardQueue(
    $queueName: String
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
  ) {
    createStandardQueue(
      queueName: $queueName
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
    )
  }
`;

export const listVPC = `
  mutation ListVPC(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
  ) {
    listVPC(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
    )
  }
`;

export const createCloudstartPremium = `
  mutation CreateCloudstartPremium(
    $region: String
    $projectName: String
    $companyName: String
  ) {
    createCloudstartPremium(
      region: $region
      projectName: $projectName
      companyName: $companyName
    )
  }
`;

export const createFeedback = `
  mutation CreateFeedback(
    $companyName: String
    $feedback: String
  ) {
    createCloudstartPremium(
      companyName: $companyName
      feedback: $feedback
    )
  }
`;

export const createGcpLandingZone = `
  mutation CreateGcpLandingZone(
    $region: String
    $domainName: String
    $projectName: String
    $companyName: String
  ) {
    createGcpLandingZone(
      region: $region
      domainName: $domainName
      projectName: $projectName
      companyName: $companyName
    )
  }
`;

export const createCloudstartLite = `
  mutation CreateCloudstartLite(
    $region: String
    $projectName: String
    $email: String
  ) {
    createCloudstartLite(
      region: $region
      projectName: $projectName
      email: $email
    )
  }
`;

export const initiateStandardVpcNonProd = `
  mutation InitiateStandardVpcNonProd(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
  ) {
    initiateStandardVpcNonProd(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
    ) {
      id
      message
      error
    }
  }
`;

export const initiateStandardVpcProd = `
  mutation InitiateStandardVpcProd(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
  ) {
    initiateStandardVpcProd(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
    ) {
      id
      message
      error
    }
  }
`;

export const initiateCustomVpc = `
  mutation InitiateCustomVpc(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
    $environment: String
    $cidr: String
    $publicSubnet1Cidr: String
    $publicSubnet2Cidr: String
    $publicSubnet3Cidr: String
    $privateSubnet1Cidr: String
    $privateSubnet2Cidr: String
    $privateSubnet3Cidr: String
  ) {
    initiateCustomVpc(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
      environment: $environment
      cidr: $cidr
      publicSubnet1Cidr: $publicSubnet1Cidr
      publicSubnet2Cidr: $publicSubnet2Cidr
      publicSubnet3Cidr: $publicSubnet3Cidr
      privateSubnet1Cidr: $privateSubnet1Cidr
      privateSubnet2Cidr: $privateSubnet2Cidr
      privateSubnet3Cidr: $privateSubnet3Cidr
    ) {
      id
      message
      error
    }
  }
`;

// export const initiateEc2WebServer = `
//   mutation InitiateEc2WebServer(
//     $vpcId: String
//     $keyName: String
//     $projectName: String
//     $envName: String
//     $subnetId: String
//     $securityGroupId: String
//     $ec2Number: Int
//     $instanceType: String
//     $region: String
//     $accessKey: String
//     $secretAccessKey: String
//     $roleArn: String
//     $externalId: String
//   ) {
//     initiateEc2WebServer(
//       vpcId: $vpcId
//       keyName: $keyName
//       projectName: $projectName
//       envName: $envName
//       subnetId: $subnetId
//       securityGroupId: $securityGroupId
//       ec2Number: $ec2Number
//       instanceType: $instanceType
//       region: $region
//       accessKey: $accessKey
//       secretAccessKey: $secretAccessKey
//       roleArn: $roleArn
//       externalId: $externalId
//     ) {
//       id
//       message
//       error
//     }
//   }
// `

export const initiateCustomEc2 = `
  mutation InitiateCustomEc2(
    $vpcId: String
    $keyName: String
    $projectName: String
    $envName: String
    $subnetId: String
    $securityGroupId: String
    $ec2Number: Int
    $instanceType: String
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
  ) {
    initiateCustomEc2(
      vpcId: $vpcId
      keyName: $keyName
      projectName: $projectName
      envName: $envName
      subnetId: $subnetId
      securityGroupId: $securityGroupId
      ec2Number: $ec2Number
      instanceType: $instanceType
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
    ) {
      id
      message
      error
    }
  }
`;

// export const initiateEc2BastionHost = `
//   mutation InitiateEc2BastionHost(
//     $vpcId: String
//     $keyName: String
//     $projectName: String
//     $envName: String
//     $subnetId: String
//     $securityGroupId: String
//     $ec2Number: Int
//     $instanceType: String
//     $region: String
//     $accessKey: String
//     $secretAccessKey: String
//     $roleArn: String
//     $externalId: String
//   ) {
//     initiateEc2BastionHost(
//       vpcId: $vpcId
//       keyName: $keyName
//       projectName: $projectName
//       envName: $envName
//       subnetId: $subnetId
//       securityGroupId: $securityGroupId
//       ec2Number: $ec2Number
//       instanceType: $instanceType
//       region: $region
//       accessKey: $accessKey
//       secretAccessKey: $secretAccessKey
//       roleArn: $roleArn
//       externalId: $externalId
//     ) {
//       id
//       message
//       error
//     }
//   }
// `

export const initiateAlbNonProd = `
  mutation InitiateAlbNonProd(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
    $primarySubnetId: String
    $secondarySubnetId: String
    $sgid: String
    $vpcid: String
    $primaryInstanceId: String
    $secondaryInstanceId: String
    $scheme: String
  ) {
    initiateAlbNonProd(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
      primarySubnetId: $primarySubnetId
      secondarySubnetId: $secondarySubnetId
      sgid: $sgid
      vpcid: $vpcid
      primaryInstanceId: $primaryInstanceId
      secondaryInstanceId: $secondaryInstanceId
      scheme: $scheme
    ) {
      id
      message
      error
    }
  }
`;

export const initiatePredefinedDatabase = `
  mutation InitiatePredefinedDatabase(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
    $primarySubnetId: String
    $secondarySubnetId: String
    $sgid: String
    $diskSize: Int
    $password: String
    $dbtype: String
    $vpcid: String,
  ) {
    initiatePredefinedDatabase(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
      primarySubnetId: $primarySubnetId
      secondarySubnetId: $secondarySubnetId
      sgid: $sgid
      diskSize: $diskSize
      password: $password
      dbtype: $dbtype
      vpcid: $vpcid
    ) {
      id
      message
      error
    }
  }
`;

export const initiateSecGroup = `
  mutation InitiateSecGroup(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
    $vpcId: String
    $source: String
    $ChoosenSource: String
  ) {
    initiateSecGroup(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
      vpcId: $vpcId
      source: $source
      ChoosenSource: $ChoosenSource
    ) {
      id
      message
      error
    }
  }
`;

export const initiatePredefinedWebTierNonProd = `
  mutation InitiatePredefinedWebTierNonProd(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
    $keypair: String
    
  ) {
    initiatePredefinedWebTierNonProd(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
      keypair: $keypair
    ) {
      id
      message
      error
    }
  }
`;

export const initiatePredefinedInstance = `
  mutation InitiatePredefinedInstance(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
    $primarySubnetId: String
    $vpcid: String
    $sgid: String
    $keyName: String
    $env: String
    $ec2Number: Int
    $ec2type: String
    
  ) {
    initiatePredefinedInstance(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
      primarySubnetId: $primarySubnetId
      vpcid: $vpcid
      sgid: $sgid
      keyName: $keyName
      env: $env
      ec2Number: $ec2Number
      ec2type: $ec2type
    
    ) {
      id
      message
      error
    }
  }
`;

export const initiatePredefinedS3BucketNonProd = `
  mutation InitiatePredefinedS3BucketNonProd(
    $bucketName: String
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
  ) {
    initiatePredefinedS3BucketNonProd(
      bucketName: $bucketName
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
    )
  }
`;

export const initiateGlobalElb = `
  mutation InitiateGlobalElb(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
    $elbType: String
    $primarySubnetId: String
    $secondarySubnetId: String
    $sgid: String
    $vpcid: String
    $primaryInstanceId: String
    $secondaryInstanceId: String
    $scheme: String
    $environment: String
    $port: Int
  ) {
    initiateGlobalElb(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
      elbType: $elbType
      primarySubnetId: $primarySubnetId
      secondarySubnetId: $secondarySubnetId
      sgid: $sgid
      vpcid: $vpcid
      primaryInstanceId: $primaryInstanceId
      secondaryInstanceId: $secondaryInstanceId
      scheme: $scheme
      environment: $environment
      port: $port
    ) {
      id
      message
      error
    }
  }
`;

export const initiatePredefinedKubernetes = `
  mutation InitiatePredefinedKubernetes(
    $region: String
    $accessKey: String
    $secretAccessKey: String
    $roleArn: String
    $externalId: String
    $projectName: String
    $primarySubnetId: String
    $secondarySubnetId: String
    $vpcid: String
    $sgid: String
    $rolearn: String
    $env: String
    
  ) {
    initiatePredefinedKubernetes(
      region: $region
      accessKey: $accessKey
      secretAccessKey: $secretAccessKey
      roleArn: $roleArn
      externalId: $externalId
      projectName: $projectName
      primarySubnetId: $primarySubnetId
      secondarySubnetId: $secondarySubnetId
      vpcid: $vpcid
      sgid: $sgid
      rolearn: $rolearn
      env: $env
    
    ) {
      id
      message
      error
    }
  }
`;
